<div class="core-invoice-preview" [class.density-business-light]="density === 'business-light'">
  <div class="inv-header inv-top">
    <div>
      @if (showLogo) {
        <div class="inv-logo has-image">
          <img class="inv-logo-img" [src]="logoUrl" alt="Business logo" />
        </div>
      }
      @if (showBusiness) {
        <div class="inv-biz">
          @if (showBusinessName) {
            <div class="inv-biz-name">{{ businessName }}</div>
          }
          @for (line of businessMetaLines; track $index) {
            <div class="inv-biz-meta">{{ line }}</div>
          }
        </div>
      }
    </div>
    @if (showInvoiceNumber || showInvoiceDate) {
      <div class="inv-title-block inv-title-right">
        @if (showInvoiceNumber) {
          <div class="inv-num inv-ref">{{ invoiceNumber }}</div>
        }
        @if (showInvoiceDate) {
          <div class="inv-date inv-ref">{{ invoiceDate }}</div>
        }
      </div>
    }
  </div>

  <div class="inv-divider"></div>

  @if (showClient) {
    <div class="inv-meta-row inv-bill-to">
      <div>
        <div class="inv-bill-label">Bill to</div>
        @if (showClientName) {
          <div class="inv-bill-name">{{ billToName }}</div>
        }
        @if (billToAttn) {
          <div class="inv-bill-attn">{{ billToAttn }}</div>
        }
        @for (line of clientMetaLines; track $index) {
          <div class="inv-bill-meta">{{ line }}</div>
        }
      </div>
    </div>
  }

  <table class="inv-table" [class.inv-preview-table]="!!tableClass">
    <thead>
      <tr>
        <th style="width:52%">Description</th>
        <th style="width:10%">Qty</th>
        <th style="width:19%">Unit price</th>
        <th style="width:19%">Amount</th>
      </tr>
    </thead>
    <tbody>
      @for (row of lineItems; track $index) {
        <tr>
          <td>{{ row.description }}</td>
          <td>{{ row.quantity }}</td>
          <td>{{ row.unitPrice | number: "1.2-2" }}</td>
          <td>{{ row.amount | number: "1.2-2" }}</td>
        </tr>
      }
    </tbody>
  </table>

  <div class="inv-totals">
    <div class="inv-tot-row">
      <span class="inv-tot-lbl">Subtotal</span>
      <span class="inv-tot-val">{{ subtotal | number: "1.2-2" }} {{ currency }}</span>
    </div>
    @if (gstAmount > 0) {
      <div class="inv-tot-row">
        <span class="inv-tot-lbl">GST (9%{{ gstInclusive ? ", incl." : "" }})</span>
        <span class="inv-tot-val">{{ gstAmount | number: "1.2-2" }} {{ currency }}</span>
      </div>
    }
    <div class="inv-grand-row">
      <span>Total</span>
      <span class="inv-grand-val">{{ total | number: "1.2-2" }} {{ currency }}</span>
    </div>
  </div>

  @if (showPaymentTerms && paymentSummary) {
    <div class="payment-block">
      <div class="pay-due">{{ paymentSummary }}</div>
    </div>
  }

  @if (showTermsAndConditions && termsText) {
    <div class="inv-terms">
      <div class="inv-terms-lbl">Terms & conditions</div>
      <div class="inv-terms-text">{{ termsText }}</div>
    </div>
  }
</div>

